import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ServiceLocationAndOperationService {
  handleSuccess(Saved_Success_00: string) {
    throw new Error('Method not implemented.');
  }

  public _ServiceLocationAndOperationService = environment.ServiceLocationAndOperationServiceLoad;
    public _httpOptions;
    public sessionId : string
    //public _DashboardList: Dashboard[] = [];
    constructor(private http: HttpClient) {
      this.sessionId =sessionStorage["SessionId"]
      this._httpOptions = {
        headers: new HttpHeaders({ 'SessionId':this.sessionId })
      };
    
     }

    ServiceLocationAndOperationServiceInit() {
      
      // 15.all the datas should fetch in particular columns.based on country code
      var Query = this._ServiceLocationAndOperationService ;
      // console.log(Query);
  
      return this.http.get<{ data: any }>(Query,this._httpOptions).pipe(map(data => {
        const resultJSON = JSON.parse(JSON.stringify(data));
        // console.log(resultJSON);        
        return data;
      }));
    }

    InserServiceLocOpt(CustomerSiteOperation: object) {
    

      // console.log("Create");
      var Query = this._ServiceLocationAndOperationService;
      return this.http.post<{ data: any }>(Query, CustomerSiteOperation,this._httpOptions);
    }
    UpdateServiceLocOpt(CustomerSiteOperation: object) {
    

      // console.log("Update");
      var Query = this._ServiceLocationAndOperationService;
      // console.log(Query);
      return this.http.put<{ data: any }>(Query, CustomerSiteOperation,this._httpOptions);
    }

    GetById(customerSiteId:string): Observable<any>{
    

      var Query = this._ServiceLocationAndOperationService + '/GetById' +'/'+ customerSiteId ;
      // console.log(Query);
      return this.http.get<{ data: any }>(Query,this._httpOptions);
    }
}
